export default __webpack_public_path__ + "static/media/va.c09c897e.svg";